<template>
  <div v-if="object && object.id > 0">
    <div class="row text-white inner-row" style="background: #e6ab8e">
      <div class="col-md-10" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{object.name + ' (' + object.pattern.name +')'}}</b>
      </div>
      <div class="col-md-2" style="text-align: right">
        <i class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>

    <simple-row :name="'Название документа'" :value="fieldView(object.name)"></simple-row>

    <div v-if="object.fields && object.fields.length > 0">
      <simple-row :name="'Список полей:'"></simple-row>
      <div class="row" v-for="(item, index) in object.fields" :key="index">
        <div class="col-md-4"> {{item.attr.substring(2, item.attr.length-2)}}</div>
        <div class="col-md-4"> {{item.value}}</div>
      </div>
    </div>

    <br/>
    <base-button @click="getFile" :size="'sm'" type="success" fill>Скачать договор</base-button>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";
 import ContractKits from "@/nestedTables/ContractKits";

 export default {
   components: {
     ContractKits,
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       tableKey: 0,
       object: this.item.object,
       inFileSelect: false,
       fileView: false,
       dataReady: false,
       links: [],
       fieldTypes: [],
       entities: []
    }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     },
     async update() {
       this.item.object = await this.$repo.get(this.object.id, 'doc');
       this.object = this.item.object;
     },
     async updatePattern() {
       await this.update();
       this.inFileSelect = false;
     },
     async getFile() {
       let fileName = this.object.pattern.pattern.name;
       fileName = this.object.name + fileName.slice(fileName.lastIndexOf('.'));
       await this.$repo.downloadFile("document/download/" + this.object.id, fileName);
     }
   },
   async mounted() {

   }
 }
</script>
<style>
</style>
